import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from '../../../../components/Button';

interface ButtonsProps {
  actionTwoLoading: boolean;
  loading: boolean;
  view: boolean;
  edit: boolean;
  external?: boolean;
  tab?: 'details' | 'attachments';
  onSubmit: (action: '1' | '2', e?: React.FormEvent) => void;
  onCancel: () => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  loading,
  actionTwoLoading,
  view,
  edit,
  external,
  tab,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(!external && "p-4")}>
      {
        !view && tab !== 'attachments' && (
          <>
            <Button
              className="btn btn-primary me-3"
              text={t("transactions.addEdit.pageTexts.form.buttons.save")}
              disabled={loading || actionTwoLoading}
              loading={loading}
              onClick={() => onSubmit('1')}
            />

            {/* {
              !edit && (
                <Button
                  className="btn btn-primary me-3"
                  text={t("transactions.addEdit.pageTexts.form.buttons.saveAndCreateNew")}
                  disabled={loading || actionTwoLoading}
                  loading={actionTwoLoading}
                  onClick={() => onSubmit('2')}
                />
              )
            } */}
          </>
        )
      }
      <Button className="btn btn-outline-secondary" text={t("transactions.addEdit.pageTexts.form.buttons.cancel")} onClick={onCancel} />
    </div>
  );
};

export default Buttons;
